export interface WeeklyGmvPoint {
  year: number
  week: number
  realizedGmv: number | null
  forecastGmv: number | null
  trajectoryGmv: number | null
}

export interface WeeklyGmvEvolution {
  weeks: WeeklyGmvPoint[]
}

export interface WeeklyGmvResponse {
  year?: number
  week?: number
  realized_gmv?: number | null
  forecast_gmv?: number | null
  trajectory_gmv?: number | null
}

export interface WeeklyGmvEvolutionResponse {
  weeks?: WeeklyGmvResponse[]
}

export const mapWeeklyGmvEvolution = (weeklyGmv?: WeeklyGmvEvolutionResponse | null): WeeklyGmvEvolution | null => {
  const weeks =
    weeklyGmv?.weeks
      ?.filter((week): week is WeeklyGmvResponse & { year: number; week: number } => !!week.year && !!week.week)
      .map(week => ({
        year: week.year,
        week: week.week,
        realizedGmv: week.realized_gmv ?? null,
        forecastGmv: week.forecast_gmv ?? null,
        trajectoryGmv: week.trajectory_gmv ?? null
      })) ?? []

  return {
    weeks
  }
}
